import { create } from 'zustand';

type ExposePreviousUrlStoreState = {
  previousUrl: string | null;
  setPreviousUrl: (previousUrl: string) => void;
  clearPreviousUrl: () => void;
};

// Reason: `next/link` navigates client-side like an SPA, so we store the previous URL for the expose back button.
export const useExposePreviousUrlStore = create<ExposePreviousUrlStoreState>((set) => ({
  previousUrl: null,
  setPreviousUrl: (previousUrl: string) => set({ previousUrl }),
  clearPreviousUrl: () => set({ previousUrl: null }),
}));
